var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid right_wrapper"},[_c('DefineGuardrailHeader'),_c('DefineNewGuardrailForm',{staticClass:"table_wrap no_footer pt-2"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }